import { convertToWebPUrl } from '@/utils/productUtils';
import { RESOLUTION } from '@/constants/gui';

type ProductImageProps = {
  url: string;
  alt?: string;
  sizeList?: any[];
  size?: string;
  position?: number;
  onClick?: () => void;
  customClassName?: string;
  fetchPriority?: boolean;
}

const ProductImage = ({
  url, alt, sizeList, size, position, onClick, customClassName, fetchPriority = false
}: ProductImageProps) => {
  const dynamicSize = sizeList && sizeList[RESOLUTION[size] + 'px'];

  const style = [
    customClassName,
    onClick && 'cursor-pointer'
  ].filter(Boolean).join(' ');

  return (
    <picture className={style} onClick={onClick}>
      <source
        type="image/webp"
        srcSet={convertToWebPUrl(url)}
      />
      <img
        loading={position > 3 ? 'lazy' : null}
        src={url}
        alt={alt}
        title={alt}
        width={dynamicSize?.width}
        height={dynamicSize?.height}
        data-test-id="product-img"
        fetchPriority={(fetchPriority && position === 0) ? 'high' : 'auto'}
      />
    </picture>
  );
};

export default ProductImage;
